import { Logo } from '@/components/Logo/Logo';

interface LogoFramedProps {
  className?: string;
}

export function LogoFramed({
  className = 'bg-black dark:bg-gray-300 text-paper dark:text-gray-800 p-3 w-full h-auto',
}: LogoFramedProps) {
  return (
    <div className={className}>
      <Logo className="fill-current block w-full h-full aspect-[271/123]" />
    </div>
  );
}
